var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCaution18 = function SvgLightIcnCaution18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE4E9",
    fillRule: "evenodd",
    d: "m7.964 2.437-6.421 11.12a1.197 1.197 0 0 0 1.036 1.796H15.42c.92 0 1.497-.997 1.036-1.795L10.036 2.437a1.196 1.196 0 0 0-2.072 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#687D91",
    fillRule: "evenodd",
    d: "M9.477 10.533c-.01.309-.258.463-.507.463-.24 0-.488-.154-.497-.463-.043-1.433-.086-2.864-.12-4.297 0-.317.292-.472.626-.472.326 0 .635.155.635.472-.052 1.433-.086 2.864-.137 4.297m-.507 1.294c.352 0 .644.292.644.635a.65.65 0 0 1-.644.652.644.644 0 0 1 0-1.287",
    clipRule: "evenodd",
    opacity: 0.6
  })));
};
export default SvgLightIcnCaution18;